export default "__VITE_ASSET__BUB2YNVq__";